import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import sortWidgets from '../../common/utils/sortWidgets';
export default class EndWidgetSection extends Component {
  view() {
    if (app.current.data.routeName !== 'index') return null;
    if (!app.widgets.get('end').length) return null;
    return m("div", {
      className: "FofWidgets-sideNavAlt FofWidgets-WidgetSection"
    }, sortWidgets(app.widgets.get('end')).map(widget => widget.component.component({
      state: widget.state
    })));
  }
}
flarum.reg.add('fof-forum-widgets-core', 'forum/components/EndWidgetSection', EndWidgetSection);